import atlantaMissionImg from './cityimages/atlanta-mission.png';
import gatewayCenterImg from './cityimages/gateway-center.png';
import hopeAtlantaImg from './cityimages/hope-atlanta.svg';
import bostonHealthcareImg from './cityimages/boston-healthcare.png';
import pineStreetInnImg from './cityimages/pine-street-inn.jpg';
import stFrancisImg from './cityimages/st-francis.svg';
import pathwaysDcImg from './cityimages/pathways-dc.png';
import someDcImg from './cityimages/some-dc.webp';
import cohDcImg from './cityimages/coh-dc.png';
import lahsaLaImg from './cityimages/lahsa-la.png';
import hhcLaImg from './cityimages/hhc-la.png';
import pathLaImg from './cityimages/path-la.png';
import boweryNycImg from './cityimages/bowery-nyc.svg';
import cambaNycImg from './cityimages/camba-nyc.png';
import covenantHouseNycImg from './cityimages/covenanthouse-nyc.png';
import centralCityPortlandImg from './cityimages/centralcity-portland.svg';
import joinPortlandImg from './cityimages/join-portland.png';
import blanchetHousePortlandImg from './cityimages/blanchethouse-portland.png';

export const CITY_RESOURCES = {
    atlanta: [
        {
            name: 'Atlanta Mission',
            img: atlantaMissionImg,
            url: 'https://atlantamission.org'
        },
        {
            name: 'Gateway Center',
            img: gatewayCenterImg,
            url: 'https://www.gatewayctr.org/'
        },
        {
            name: 'HOPE Atlanta',
            img: hopeAtlantaImg,
            url: 'https://www.hopeatlanta.org'
        }
    ],
    boston: [
        {
            name: 'Boston Health Care for the Homeless Program',
            img: bostonHealthcareImg,
            url: 'https://www.bhchp.org/'
        },
        {
            name: 'Pine Street Inn ',
            img: pineStreetInnImg,
            url: 'https://www.pinestreetinn.org/'
        },
        {
            name: 'St. Francis House ',
            img: stFrancisImg,
            url: 'https://www.stfrancishouse.org/'
        }
    ],
    dc: [
        {
            name: 'Pathways to Housing DC',
            img: pathwaysDcImg,
            url: 'https://pathwaystohousingdc.org'
        },
        {
            name: 'SOME (So Others Might Eat) ',
            img: someDcImg,
            url: 'https://www.some.org'
        },
        {
            name: 'Community of Hope ',
            img: cohDcImg,
            url: 'https://www.communityofhopedc.org'
        }
    ],
    la: [
        {
            name: 'Los Angeles Homeless Services Authority ',
            img: lahsaLaImg,
            url: 'https://www.lahsa.org/'
        },
        {
            name: 'Homeless Health Care Los Angeles',
            img: hhcLaImg,
            url: 'https://www.hhcla.org'
        },
        {
            name: 'PATH',
            img: pathLaImg,
            url: 'https://epath.org/regions/greater-los-angeles/'
        }
    ],
    nyc: [
        {
            name: 'The Bowery Mission',
            img: boweryNycImg,
            url: 'https://www.bowery.org'
        },
        {
            name: 'CAMBA',
            img: cambaNycImg,
            url: 'https://www.camba.org'
        },
        {
            name: 'Covenant House New York ',
            img: covenantHouseNycImg,
            url: 'https://ny.covenanthouse.org'
        }
    ],
    portland: [
        {
            name: 'Central City Concern',
            img: centralCityPortlandImg,
            url: 'https://centralcityconcern.org/'
        },
        {
            name: 'JOIN',
            img: joinPortlandImg,
            url: 'https://joinpdx.org/'
        },
        {
            name: 'Blanchet House ',
            img: blanchetHousePortlandImg,
            url: 'https://blanchethouse.org/'
        }
    ]
};